import { json } from '@remix-run/node'

import searchResolver from '~/services/resolvers/search'
import getApp from '~/utils/getApp'
import getScope from '~/utils/scope'

import serverErrorHandler from '~/utils/serverErrorHandler'

import type { LoaderFunction } from '@remix-run/node'

export const loader: LoaderFunction = async ({ request, params }) => {
    const app = getApp(request.url)

    if (app instanceof Response) {
        return app
    }

    const scope = getScope(app, request.url)

    if (scope instanceof Response) {
        return scope
    }
    
    try {
        const results = await searchResolver({
            app: app,
            scope: scope,
            url: request.url
        })


        return json({
            ...app,
            ...params,
            ...results
        })
    } catch(result: any) {

        await serverErrorHandler(request, result, scope.id)

        return json({
            ...app,
            ...params,
            payload: {}
        })
    }
}

export { default } from '~/pages/Widgets'
